export const TimeFormat_HHmm = 'HH:mm';
export const TimeFormats = [TimeFormat_HHmm];
//# sourceMappingURL=types.js.map